import React from "react";
import BlogSection from "components/BlogSection";
import Head from 'next/head';

function BlogPage(props) {
  return (
    <>
      <Head>
        <title>Browser Productivity Blog | tabExtend</title>
        <meta
          name="description"
          content="Tips, workflows, and productivity guides for managing browser tabs, projects, and focus with tabExtend."
        />
        <meta property="og:title" content="Browser Productivity Blog | tabExtend" />
        <meta
          property="og:description"
          content="Tips, workflows, and productivity guides for managing browser tabs, projects, and focus with tabExtend."
        />
        <meta property="og:url" content="https://www.tabextend.com/blog" />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.tabextend.com/blog" />
      </Head>
      <BlogSection/>
    </>
  );
}

export default BlogPage;
